import "./style.css";


export default function Header () {

    return(
        <header >
            <a href="/"><h1 >Where in the world ?</h1></a>
        </header>
    )
}